enum CouponStatus {
  ENABLED = "enabled",
  DISABLED = "disabled",
  FORBIDDEN = "forbidden",
}

export default CouponStatus;
